import { all, call, fork, takeEvery } from "redux-saga/effects";
import { fetchAllUserActivitySuccess } from "../Actions";
import { getAllActivityByUserIdApi } from "../Api";
import requestFunction from "../Utils/SagaGenericFunction";
import { FETCH_ALL_USER_ACTIVITY } from "../ActionTypes";

// activity request
const getAllActivityRequest = function* ({ payload }) {
  yield call(
    requestFunction,
    fetchAllUserActivitySuccess,
    getAllActivityByUserIdApi,
    payload
  );
};

export const getAllActivityWatcher = function* () {
  yield takeEvery(FETCH_ALL_USER_ACTIVITY, getAllActivityRequest);
};


export default function* rootSaga() {
    yield all([
      fork(getAllActivityWatcher),
    
    ]);
  }
